export const SITE = {
  name: "Nyra Namkeen",
  tagline: "Taste Nahi, Feelings Hai!",
  company: "Yashika Foods & Snacks Enterprises",
  email: "nyranamkeen@gmail.com",
  phone: "+91 7050273011",
  location: "Jehanabad, Bihar, India",
  address:
    "Yashika Foods & Snacks Enterprises, Hiramani Niwas, Lakshmi Nagar, Kohra, Jehanabad, Bihar 804227, India.",
  social: {
    facebook: "https://www.facebook.com/share/18gwv7QeG8/",
    instagram: "https://www.instagram.com/nyranamkeen",
    youtube: "https://youtube.com/@nyranamkeen?si=kU62v8Olp8QRFCU3",
  },
};
